import React, { useState, useEffect } from 'react';
import { QuickGuide } from './QuickGuide/QuickGuide';
import { DetailedRules } from './DetailedRules/DetailedRules';
import { NineSliceModal } from '../../components/ui';
import { modalContentStyles, tabStyles, zIndex } from '../../styles';

interface HelpModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialTab?: 'quick' | 'detailed';
  initialSubTab?: string;
}

export const HelpModal: React.FC<HelpModalProps> = ({
  isOpen,
  onClose,
  initialTab = 'quick',
  initialSubTab,
}) => {
  const [activeTab, setActiveTab] = useState<'quick' | 'detailed'>(initialTab);

  // 初期タブ設定
  useEffect(() => {
    if (isOpen) {
      setActiveTab(initialTab);
    }
  }, [isOpen, initialTab]);

  return (
    <NineSliceModal
      isOpen={isOpen}
      onClose={onClose}
      variant="default"
      width="90vw"
      maxWidth={800}
      height="80vh"
      maxHeight={800}
      padding={20}
      zIndex={zIndex.max}
    >
      <div style={modalContentStyles.container}>
        {/* ヘッダー */}
        <div style={modalContentStyles.header}>
          <h2 id="help-modal-title" style={modalContentStyles.title}>
            遊び方ガイド
          </h2>
          <button
            onClick={onClose}
            style={modalContentStyles.closeButton}
            aria-label="閉じる"
          >
            ✕
          </button>
        </div>

        {/* メインタブ */}
        <div style={tabStyles.container}>
          <button
            onClick={() => setActiveTab('quick')}
            style={{
              ...tabStyles.tab,
              ...(activeTab === 'quick' ? tabStyles.active : tabStyles.inactive),
            }}
          >
            クイックガイド
          </button>
          <button
            onClick={() => setActiveTab('detailed')}
            style={{
              ...tabStyles.tab,
              ...(activeTab === 'detailed' ? tabStyles.active : tabStyles.inactive),
            }}
          >
            詳細ルール
          </button>
        </div>

        {/* コンテンツ */}
        <div style={modalContentStyles.scrollableContent}>
          {activeTab === 'quick' ? (
            <QuickGuide />
          ) : (
            <DetailedRules initialTab={initialSubTab} />
          )}
        </div>
      </div>
    </NineSliceModal>
  );
};

export default HelpModal;
